export default __webpack_public_path__ + "static/transaction-states-v2-79a88e37bc22d8a086074216add6b2fa.png";